import angular from "angular";

import { CalendarActionType, CalendarEvent, CalendarEvents, Dates, DateTimes, Translations, CalendarEventListItem } from "@salaxy/core";

import { UiHelpers} from "../../services";
import { ApiCrudObjectController } from "../bases";

/**
 * Controller for implementing Calendars that contain CalendarEvents (iCalendar).
 */
export class CalendarEventsCrudController extends ApiCrudObjectController<CalendarEvent, CalendarEventListItem> {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = [
    "CalendarEvents",
    "UiHelpers",
    "$location",
    "$routeParams",
  ];

  public endMinDate: string;

  public _tabOptions: any[] = [];


  /**
   * Creates a new WorkflowController
   * @ignore
   */
  constructor(
    private fullApi: CalendarEvents,
    uiHelpers: UiHelpers,
    $location: angular.ILocationService,
    $routeParams: any,
  ) {
    super(fullApi, uiHelpers, $location, $routeParams);
  }

  /**
   * Controller initialization
   */
  public $onInit() {
    super.$onInit();
  }

  /** Dynamic tabs */
  public get tabOptions(): any[] {
    if (this._tabOptions.length == 0) {
      this._tabOptions.push(...[
        { value: "basic", text: "Perustiedot" },
        { value: "recurrence" },
        { value: "actions" },
        { value: "debug", text: "Debug" }
      ]);
    }
    if (this.current) {
      this._tabOptions.find((x) => x.value == "recurrence").text = `Toistuvuus (${this.current?.event?.recurrenceRules?.length || "ei toistu"})`;
      this._tabOptions.find((x) => x.value == "actions").text = `Tehtävät (${this.current?.event.actions?.length || 0})`;

    }
    return this._tabOptions;
  }

  /** Implements the getDefaults of ApiCrudObjectController */
  public getDefaults() {
    return {
      listUrl: this.listUrl || "/calendar",
      detailsUrl: this.detailsUrl || "/calendar/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/calendar/Events.html",
      oDataOptions: {},
    };
  }

  /** Adds a new recurrence rule to the event */
  public addRecurrenceRule() {
    this.current.event.recurrenceRules = this.current.event.recurrenceRules || [];
    this.current.event.recurrenceRules.push("FREQ=MONTHLY;INTERVAL=1");
  }

  /** Adds a new action to the event */
  public addAction() {
    this.current.event.actions = this.current.event.actions || [];
    this.current.event.actions.push({ type: CalendarActionType.Script});
  }

  /**
   * Deletes an item in the recurrence rules
   * @param index The index number of the item to delete.
   */
  public deleteRecurrence(index: number): void {
    this.current.event.recurrenceRules.splice(index, 1);
  }

  /**
   * Deletes an item in the actions
   * @param index The index number of the item to delete.
   */
  public deleteAction(index: number): void {
    this.current.event.actions.splice(index, 1);
  }

  /**
   * Saves the calendar item.
   * Override done so that durations (timespans) are converted from number to string.
   */
  public save(): Promise<CalendarEvent> {
    this.checkDurations();
    return super.save();
  }

  /** Gets the event duration, even if it is null (start and end defined). */
  public getEventDuration() {
    if (!this.current) {
      return null;
    }
    if (this.current.event.duration) {
      return DateTimes.formatDuration(this.current.event.duration);
    }
    let end = this.current.event.end ?? this.current.event.start;
    if (end < this.current.event.start) {
      return Translations.get("SALAXY.NG1.ODataCalendarEventComponent.getEventDurationError");
    }
    if (this.current.event.isAllDay) {
      end = Dates.add(end, 1, "day");
    }
    return DateTimes.formatRangeToDuration(this.current.event.start, end);
  }

  /** Assures that the durations are strings, not numbers. The UI binding makes them numbers. */
  public checkDurations() {
    if (this.current?.event.duration) {
      this.current.event.duration = this.current.event.duration.toString();
    }
    (this.current?.event.actions || []).forEach((action) => {
      if (action.triggerDuration) {
        action.triggerDuration = action.triggerDuration.toString();
      }
    });
  }
}
